import { render, staticRenderFns } from "./getMore.vue?vue&type=template&id=48a247ad&"
import script from "./getMore.vue?vue&type=script&lang=ts&"
export * from "./getMore.vue?vue&type=script&lang=ts&"
import style0 from "./getMore.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports